// Copyright (c) Microgreen Manager LLC. All rights reserved. Proprietary and confidential. Unauthorized copying is strictly prohibited.
// biome-ignore lint/style/useImportType: <explanation>
import * as React from 'react';
import { preloadHarvestView } from '../../App';
import { Link } from '../../lib/link';
import * as routes from '../../routes';
import { formatHarvestName } from '../../utils';

interface Props {
  readonly id: string;
  readonly title?: string | React.ReactElement;
}

export default function HarvestLink({ id, title }: Props) {
  return (
    <Link
      onMouseOver={() => preloadHarvestView()}
      path={routes.makeHarvestIdPath(id)}
      title={title ?? formatHarvestName(id)}
    />
  );
}
